


































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, PropSync } from 'vue-property-decorator'

@Component({
  inheritAttrs: false
})
export default class InputRange extends Vue {
  @Prop({ default: '' }) label!: string
  @PropSync('from') fromValue!: string
  @PropSync('to') toValue!: string
  @Prop({ default: true }) showFrom!: boolean
  @Prop({ default: true }) showTo!: boolean
  @Prop() max: number
  @Prop() min: number
}
